module.exports = __webpack_public_path__ + "03_short_brown.933fafb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_short_brown.png
// module id = rDDT
// module chunks = 0